import Vue from "vue";
import { numberFormat } from "@/helpers/util.js";
const vm = new Vue();
import { helpers } from "vuelidate/lib/validators";
import popStorage from "@/constants/LocalStorageManagement";

export const fetchWalletBanlancesToLocalStorage = async (use_wallet_v2 = false) => {
  const api_path = use_wallet_v2
    ? "/wallet_v2/agent/wallet/info"
    : "/wallet/account/wallet/info";

  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + api_path, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        console.log('> res.data.data: ', res.data.data)
        if (res.data && res.data.data) {
          popStorage.wallet().set({
            status           : res.data.status,
            available_balance: res.data.data.available_balance,
            balance          : res.data.data.balance,
            peg_balance      : res.data.data.peg_balance,
          });
          resolve(res.data.data);
        } else {
          console.error('> Error: fetch wallet balances return empty')
        }
      })
      .catch(err => reject(err));
  });
};

export const fetchWalletMetadataToLocalStorage = async (use_wallet_v2 = false) => {
  const api_path = "/shop_wallet/wallet_metadata";

  return new Promise((resolve, reject) => {
    if (!use_wallet_v2) { resolve(); }

    vm.$http
      .get(vm.$API_URL + api_path, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        if (res.data && res.data.data) {
          popStorage.walletMetadata().set({
            id:       res.data.data.id,
            email:    res.data.data.email,
            enabled:  res.data.data.enabled,
            verified: res.data.data.verified,
          });
          resolve(res.data.data);
        } else {
          console.error('> Error: fetch wallet metadata return empty')
        }
      })
      .catch(err => reject(err));
  });
};

export const fetchShopMetadataToLocalStorage = async () => {
  const api_path = "/shop/shop_metadata";

  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + api_path, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        if (res.data && res.data.data) {
          popStorage.shopMetadata().set({
            id:           res.data.data.id,
            name:         res.data.data.name,
            owner_name:   res.data.data.owner_name,
            postcode:     res.data.data.podtcode,
            payment_type: res.data.data.payment_type,
            status_shop:  res.data.data.status_shop,
            created_at:   res.data.data.created_at,
            walletv2_launched_date: res.data.data.walletv2_launched_date,
          });
          resolve(res.data.data);
        } else {
          console.error('> Error: fetch shop metadata return empty')
        }
      })
      .catch(err => reject(err));
  });
};

export const checkWithDrawAmount = (value) =>
  !helpers.req(value) || !(value < 100);

export const statusPayment = (status, subject = null) => {
  switch (String(status)) {
    case "0":
      return { status: `รออนุมัติ`, color: `warning`, icon: `far fa-clock` };
    case "1":
      return {
        status: subject == "cancel-pend-withdraw" ? `คืนเงิน` : `สำเร็จ`,
        color: subject == "cancel-pend-withdraw" ? `primary` : `success`,
        icon:
          subject == "cancel-pend-withdraw"
            ? `fas fa-long-arrow-alt-right`
            : `far fa-check-circle`,
      };
    case "2":
      return {
        status: `ยกเลิกสำเร็จ`,
        color: `success`,
        icon: `far fa-check-circle`,
      };
    default:
      return { status: `ไม่มีสถานะ`, color: `dark`, icon: `fas fa-question` };
  }
};

export const statusPaymentSubject = (subject) => {
  const isSuperadmin = vm.$USER_LOGIN.get().isSuperadmin;
  switch (String(subject)) {
    case "deposit":
    case "pend-deposit":
    case "pend-deposit-confirmed":
      return {
        text: isSuperadmin ? `ค่าขนส่ง` : `เติมเครดิต`,
        color: `success`,
      };
    case "cancel-pend-deposit":
    case "pend-deposit-cancelled":
      return {
        text: isSuperadmin ? `ยกเลิกรายการขนส่ง` : `ยกเลิกรายการเติมเครดิต`,
        color: `warning`,
      };
    case "withdraw":
    case "pend-withdraw":
    case "pend-withdraw-confirmed":
      return { text: `ค่าขนส่ง`, color: `warning` };
    case "cancel-pend-withdraw":
    case "pend-withdraw-cancelled":
      return { text: `ยกเลิกรายการขนส่ง`, color: `warning` };
    default:
      return { text: `ไม่มีสถานะ`, color: `dark` };
  }
};

export const statusPaymentChannel = (subject) => {
  switch (String(subject)) {
    case "DEPOSIT_PGW":
      return { text: `เติมเงินโดยร้านค้า`, color: `warning` };
    case "DEPOSIT_INSTANT":
      return { text: `เติมเงินโดย SuperAdmin`, color: `success` };
    default:
      return { text: `ไม่มีสถานะ`, color: `dark` };
  }
};

export const checkStatusPending = (str) => {
  return /^(pend).*/.test(str);
};

export const rowClass = (item, type) => {
  if (!item || type !== "row") return;
  if (!checkStatusPending(item.subject)) return;
  return "text-muted";
};
export const rowClassTransaction = (item) => {
  let res = { text: "", fontColor: "" };
  const credit = " ฿" + numberFormat(item.credit);
  if (["pend-deposit", "pend-deposit-confirmed"].includes(item.subject)) {
    res.text = "+" + credit;
  } else if (item.subject === "deposit") {
    res.text = "+" + credit;
    res.fontColor = "text-success";
  } else if (
    ["pend-withdraw", "pend-withdraw-confirmed"].includes(item.subject)
  ) {
    res.text = "-" + credit;
  } else if (item.subject === "withdraw") {
    res.text = "-" + credit;
    res.fontColor = "text-danger";
  } else if (
    ["cancel-pend-withdraw", "pend-withdraw-cancelled"].includes(item.subject)
  ) {
    res.text = "+" + credit;
    res.fontColor = "text-primary";
  }
  return res;
};
export const checkStatusRefNo2 = (status) => {
  if (status === "DEPOSIT_PGW") return "เติมผ่านระบบ";
  if (status === "DEPOSIT_INSTANT") return "เติมผ่านผู้ดูแล";
  return status;
};

export const convertDataWallet = (data) => {
  if (data.length < 1) return data;
  data.forEach((val) => {
    let transactionFormat = rowClassTransaction(val).text;
    let statusFormat = statusPayment(val.status, val.subject).status;

    val.status = statusFormat;
    val.subject = statusPaymentSubject(val.subject).text;
    val.ref_no2 = checkStatusRefNo2(val.ref_no2);
    val.credit = `${transactionFormat}`;
  });
  return data;
};

export const walletTopup = (credit, use_wallet_v2) => {
  const api_path = use_wallet_v2
    ? "/wallet_v2/agent/transaction/deposit/pending/pgw"
    : "/wallet/agent/transaction/pgw/deposit";

  return new Promise((resolve, reject) => {
    vm.$http
      .post(
        vm.$API_URL + api_path,
        {
          credit: credit,
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        if (!res.data.status) {
          reject(res.data.error);
        }

        resolve(res.data.data.url);
      })
      .catch(() => {});
  });
};

export const modAmount = (amount) => {
  let mod = vm.$THEME.amountWalletMod ? vm.$THEME.amountWalletMod : 1;
  if (amount % mod == 0) {
    return false;
  }

  return true;
};

export const checkFillAmount = (value) => modAmount(value);

export const errorWalletUpdateParcel = {
  CREDIT_MORE_THAN: "CREDIT_MORE_THAN",
  CREDIT_LESS: "CREDIT_LESS",
  TOPUP: "TOPUP",
  NOT_ENOUGH_BALANCE: "NOT_ENOUGH_BALANCE",
};
